
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/google-tag-manager-services",
      function () {
        return require("private-next-pages/services/google-tag-manager-services.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/google-tag-manager-services"])
      });
    }
  